import React from 'react';
import { Link } from 'react-router-dom';

const AdminPage = () => (
  <div>
    <h1>
      AdminPage
    </h1>
    <Link to="/admin/add-vendors">
      Add Vendor
    </Link>

  </div>
);

export default AdminPage;



// WEBPACK FOOTER //
// ./src/components/admin/AdminPage.js